var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBenchmarkDimmed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0977 15.1955H1.85192V0.902234C1.8535 0.784315 1.83163 0.667258 1.78759 0.55786C1.74355 0.448463 1.67821 0.348904 1.59538 0.264965C1.51254 0.181025 1.41386 0.114378 1.30505 0.0688922C1.19625 0.0234067 1.07949 -1.04796e-05 0.961561 3.51815e-09C0.722274 3.51815e-09 0.492787 0.0950562 0.323585 0.264258C0.154383 0.43346 0.0593262 0.662947 0.0593262 0.902234V16.0978C0.0593262 16.3371 0.154383 16.5665 0.323585 16.7357C0.492787 16.9049 0.722274 17 0.961561 17H16.0977C16.337 17 16.5665 16.9049 16.7357 16.7357C16.9049 16.5665 17 16.3371 17 16.0978C17 15.8585 16.9049 15.629 16.7357 15.4598C16.5665 15.2906 16.337 15.1955 16.0977 15.1955V15.1955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09005 7.28918H3.0272C2.82395 7.28918 2.65918 7.45395 2.65918 7.6572V14.1865C2.65918 14.3898 2.82395 14.5545 3.0272 14.5545H6.09005C6.2933 14.5545 6.45806 14.3898 6.45806 14.1865V7.6572C6.45806 7.45395 6.2933 7.28918 6.09005 7.28918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5538 3.41895H7.65717C7.40803 3.41895 7.20605 3.62092 7.20605 3.87006V14.1152C7.20605 14.3643 7.40803 14.5663 7.65717 14.5663H10.5538C10.803 14.5663 11.0049 14.3643 11.0049 14.1152V3.87006C11.0049 3.62092 10.803 3.41895 10.5538 3.41895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2429 9.47351H12.0613C11.8909 9.47351 11.7527 9.6117 11.7527 9.78217V14.2577C11.7527 14.4282 11.8909 14.5664 12.0613 14.5664H15.2429C15.4134 14.5664 15.5516 14.4282 15.5516 14.2577V9.78217C15.5516 9.6117 15.4134 9.47351 15.2429 9.47351Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenchmarkDimmed);
export default __webpack_public_path__ + "static/media/benchmark_dimmed.4da99f2e.svg";
export { ForwardRef as ReactComponent };